import {Game} from "../Game";
import {MXRunner} from "./MXRunner";

export class MaxWinRunner extends MXRunner {

    public shouldRun(): boolean {
        return !Game.isMaxWinByMXSymbol() && Game.model.gameData.brokeTheBank;
    }
}